export default "__VITE_ASSET__B2fA1sVi__"